var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloseDetails({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 9.25H9.25H6.5M17.5 9.25C17.5 10.3334 17.2866 11.4062 16.872 12.4071C16.4574 13.4081 15.8497 14.3175 15.0836 15.0836C14.3175 15.8497 13.4081 16.4574 12.4071 16.872C11.4062 17.2866 10.3334 17.5 9.25 17.5C8.16659 17.5 7.0938 17.2866 6.09286 16.872C5.09193 16.4574 4.18245 15.8497 3.41637 15.0836C2.65029 14.3175 2.0426 13.4081 1.62799 12.4071C1.21339 11.4062 1 10.3334 1 9.25C1 7.06196 1.86919 4.96354 3.41637 3.41637C4.96354 1.86919 7.06196 1 9.25 1C11.438 1 13.5365 1.86919 15.0836 3.41637C16.6308 4.96354 17.5 7.06196 17.5 9.25Z",
    stroke: "black",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseDetails);
export default __webpack_public_path__ + "static/media/closeDetails.f1333119cdd418acea72a7da79b158ce.svg";
export { ForwardRef as ReactComponent };